<template>
  <div
    class="container xl:max-w-5.75xl lg:max-w-4.5xl md:max-w-2.625xl sm:max-w-0.25xl w-full lg:h-14 h-10 flex flex-nowrap basis-auto justify-between items-center mx-auto lg:px-3.75"
  >
    <div class="mr-9 pt-1.5">
      <a class="inline-block py-2.5 whitespace-nowrap w-[150.45px]" href="#">
        <img class="h-7.5" alt="..." src="@/assets/images/tss_logo_v3.png" />
      </a>
    </div>
    <div class="relative inline-block lg:hidden w-11">
      
    </div>
    <div class="hidden basis-auto lg:flex items-center w-full">
      
      
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Shop } from '@element-plus/icons-vue'
import { MenuIcon, XIcon } from '@heroicons/vue/outline'

export default defineComponent({
  name: 'AuthenticationNav',
  components: {
    Shop,
    XIcon,
    MenuIcon,
  },
  setup() {
    return {}
  },
})
</script>
